import { render, staticRenderFns } from "./quest-pager.vue?vue&type=template&id=6bca29c3"
import script from "./quest-pager.vue?vue&type=script&lang=js"
export * from "./quest-pager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports